import { BaseContainer } from "../../components/container"
import { PageTitle } from "../../components/page_sections"
import SearchDotIcon from "../../assets/icons/search_dot"
import Typography from "../../components/typography"
import Card from "../../components/card"
import { useHistory } from "react-router-dom"
import { Box } from "@material-ui/core"
import { TwoLineText } from '../../components/two_line_text'
import config from "../../config"

const Discover = () => {
    const history = useHistory()

    return (
        <BaseContainer showNav discover>
            <PageTitle icon={<SearchDotIcon/>}>
                Discover
            </PageTitle>

            <Box mb={3}>
                <Typography variant="bodyTextMedium">
                    Here you can find additional information on vaccinations and health
                </Typography>
            </Box>

            {config.region == 'HKG' && (
                <Card title="Hong Kong Vaccine Schedule" onClick={() => {
                    history.push('/discover/schedule/hkg')
                }}/>
            )}
            {config.region == 'GBR' && (
                <>
                    <Card onClick={() => {
                        history.push('/discover/schedule/gbr/pre_july_2024')
                    }}>
                        <TwoLineText>
                            <Typography variant="bodyTextMediumBold">
                                UK Routine Vaccination Schedule
                            </Typography>
                            <Typography variant="bodyTextMedium">
                                (Born BEFORE 1 July 2024)
                            </Typography>
                        </TwoLineText>
                    </Card>
                    <Card onClick={() => {
                        history.push('/discover/schedule/gbr/post_july_2024')
                    }}>
                        <TwoLineText>
                            <Typography variant="bodyTextMediumBold">
                                UK Routine Vaccination Schedule
                            </Typography>
                            <Typography variant="bodyTextMedium">
                                (Born AFTER 1 July 2024)
                            </Typography>
                        </TwoLineText>
                    </Card>
                </>
            )}
        </BaseContainer>
    )
}

export default Discover
